import React from 'react';

import { GlobalFeedbackCollector } from '@confluence/global-feedback-collector/entry-points/GlobalFeedbackCollector.ts';

import type { ContentFeedbackService } from './services/content-types-feedback-service.ts';
import { useGlobalFeedbackCollector } from './hooks/useGlobalFeedbackCollector.ts';

export type GlobalFeedbackCollectorModalProps = {
	feedbackService: ContentFeedbackService;
};

export const GlobalFeedbackCollectorModal = ({
	feedbackService,
}: GlobalFeedbackCollectorModalProps): React.JSX.Element | null => {
	const modalState = useGlobalFeedbackCollector(feedbackService);

	if (!modalState.isModalOpen) {
		return null;
	}

	return (
		<GlobalFeedbackCollector {...modalState.modalProps} onClose={() => modalState.closeModal()} />
	);
};
